import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import OrderTag from "@/enum/OrderTag";
import { PlatformOrderInfo } from "..";
import { isOtherDropShippingSupplierPlatform } from "./otherDropShippingSupplier";

export function transformAliOutOrderTag2PlatformType(orderTag: OrderTag) {
    if (orderTag === OrderTag.ALI_OUT_ORDER_TAOBAO) {
        return MultiShopSelectPlatformType.ali_out_order_taobao;
    }

    if (orderTag === OrderTag.ALI_OUT_ORDER_PDD) {
        return MultiShopSelectPlatformType.ali_out_order_pdd;
    }
    if (orderTag === OrderTag.ALI_OUT_ORDER_DY) {
        return MultiShopSelectPlatformType.ali_out_order_dy;
    }
    if (orderTag === OrderTag.ALI_OUT_ORDER_KWAI) {
        return MultiShopSelectPlatformType.ali_out_order_kwai;
    }
    if (orderTag === OrderTag.ALI_OUT_ORDER_XHS) {
        return MultiShopSelectPlatformType.ali_out_order_xhs;
    }
    if (orderTag === OrderTag.ALI_OUT_ORDER_JD) {
        return MultiShopSelectPlatformType.ali_out_order_jd;
    }
    if (orderTag === OrderTag.ALI_OUT_ORDER_WEIXIN) {
        return MultiShopSelectPlatformType.ali_out_order_weixin;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_taobao;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_pdd;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_dy;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_kwai;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_xhs;
    }
    if (orderTag === OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD) {
        return MultiShopSelectPlatformType.ali_plaintext_out_order_jd;
    }

    return undefined;
}

export function transformPlatformType2AliOutOrderTag(platformType: MultiShopSelectPlatformType) {
    if (platformType === MultiShopSelectPlatformType.ali_out_order_taobao) {
        return OrderTag.ALI_OUT_ORDER_TAOBAO;
    }

    if (platformType === MultiShopSelectPlatformType.ali_out_order_pdd) {
        return OrderTag.ALI_OUT_ORDER_PDD;
    }
    if (platformType === MultiShopSelectPlatformType.ali_out_order_dy) {
        return OrderTag.ALI_OUT_ORDER_DY;
    }
    if (platformType === MultiShopSelectPlatformType.ali_out_order_kwai) {
        return OrderTag.ALI_OUT_ORDER_KWAI;
    }
    if (platformType === MultiShopSelectPlatformType.ali_out_order_xhs) {
        return OrderTag.ALI_OUT_ORDER_XHS;
    }

    if (platformType === MultiShopSelectPlatformType.ali_out_order_jd) {
        return OrderTag.ALI_OUT_ORDER_JD;
    }

    if (platformType === MultiShopSelectPlatformType.ali_out_order_weixin) {
        return OrderTag.ALI_OUT_ORDER_WEIXIN;
    }

    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_taobao) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO;
    }
    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_pdd) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD;
    }
    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_dy) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY;
    }
    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_kwai) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI;
    }
    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_xhs) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS;
    }
    if (platformType === MultiShopSelectPlatformType.ali_plaintext_out_order_jd) {
        return OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD;
    }

    return undefined;
}

export function classifyPlatformOrderInfo(platformOrderInfo: PlatformOrderInfo) {
    /** @ts-ignore */
    const ali: PlatformOrderInfo = {};
    /** @ts-ignore */
    const standard: PlatformOrderInfo = {};
    /** @ts-ignore */
    const otherDropShippingSupplier: PlatformOrderInfo = {};

    Object.keys(platformOrderInfo).forEach((platform: MultiShopSelectPlatformType) => {
        if (!platformOrderInfo[platform]?.length) return;

        if (platform.startsWith("ali")) {
            ali[platform] = platformOrderInfo[platform];
        } else if (isOtherDropShippingSupplierPlatform(platform)) {
            otherDropShippingSupplier[platform] = platformOrderInfo[platform];
        } else {
            standard[platform] = platformOrderInfo[platform];
        }
    });

    return {
        aliPlatformOrderInfo: ali,
        standardPlatformOrderInfo: standard,
        otherDropShippingSupplierPlatformOrderInfo: otherDropShippingSupplier,
    };
}
